import React, { type PropsWithChildren } from 'react';

import { PasswordlessLoginTokenContext } from '../../contexts/passwordlessLoginTokenContext';
import { usePasswordlessLoginTokenQueryParam } from '../../Login';

const PasswordlessLoginTokenProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const value = usePasswordlessLoginTokenQueryParam();

  return (
    <PasswordlessLoginTokenContext.Provider value={value}>
      {children}
    </PasswordlessLoginTokenContext.Provider>
  );
};

export default PasswordlessLoginTokenProvider;
